import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createExternalRelationAsync, deleteExternalRelationAsync, getAllExternalRelationsAsync, getExternalRelationByIdAsync, updateExternalRelationAsync, getAllExternalRelationsWithoutPaginationAsync, getAllExternalRelationRecentEventsAsync } from './externalRelationsThunk';
const initialState = {
    status: APIStatus.IDLE,
    externalRelations: null,
    selectedExternalRelation: null,
    externalRelation: null,
    searchString: null
};
export const externalRelationsSlice = createSlice({
    name: 'externalRelations',
    initialState,
    reducers: {
        resetExternalRelationsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedExternalRelation(state) {
            state.selectedExternalRelation = null;
        },
        resetSearchString(state) {
            state.searchString = null;
        },
        setSearchString(state, action) {
            state.searchString = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get All
            .addCase(getAllExternalRelationsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllExternalRelationsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelations = action.payload;
        })
            .addCase(getAllExternalRelationsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            // Create
            .addCase(createExternalRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createExternalRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelation = action.payload.data;
        })
            .addCase(createExternalRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Get By Id
            .addCase(getExternalRelationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getExternalRelationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedExternalRelation = action.payload;
        })
            .addCase(getExternalRelationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Update
            .addCase(updateExternalRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateExternalRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedExternalRelation = action.payload;
            state.externalRelation = action.payload;
        })
            .addCase(updateExternalRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Delete
            .addCase(deleteExternalRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteExternalRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.externalRelations && Array.isArray(state.externalRelations.items) && action.payload) {
                const data = action.payload;
                state.externalRelations.items = state.externalRelations.items.filter((x) => x.id !== data.id);
            }
        })
            .addCase(deleteExternalRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllExternalRelationsWithoutPaginationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllExternalRelationsWithoutPaginationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allExternalRelations = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllExternalRelationsWithoutPaginationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllExternalRelationRecentEventsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllExternalRelationRecentEventsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelationRecentEvent = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllExternalRelationRecentEventsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetExternalRelationsApiState, clearSelectedExternalRelation, resetSearchString, setSearchString } = externalRelationsSlice.actions;
export default externalRelationsSlice.reducer;
